import { ADULT_RATING_AGE, isAdult } from '@/shared/utils';

export default {
  data() {
    return {
      isAgeVerified: false,
    };
  },
  methods: {
    verifyAgePromise() {
      return new Promise((resolve, reject) => {
        if (this.isAgeVerified) {
          return resolve();
        }

        const rating = this.product.rating;
        if (!rating || rating < ADULT_RATING_AGE || isAdult(this.subscriber.dateOfBirth)) {
          return resolve();
        }
        this.verifyAgeResponses = { resolve, reject };
        this.isVerifyAgeVisible = true;
      });
    },
    AgeConfirmed() {
      this.isVerifyAgeVisible = false;
      this.isAgeVerified = true;
      this.verifyAgeResponses.resolve();
    },
    AgeRejected() {
      this.isVerifyAgeVisible = false;
      this.verifyAgeResponses.reject();
    },
  },
};
